import React from 'react'
import { KeyboardArrowDown } from '@mui/icons-material';
import "./App.css"



const products = ["DataArchiva", "DataArchiva Pro"]

function SelectProduct({ product, setProduct, error, touched, setTouched }) {



    const handleChange = (event) => {
        let value = event.target.value
        setProduct(value);
        if (value) {
            setTouched(false)
        }

    };


    return (
        <>
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <select
                    id="products"
                    value={product}
                    className={touched ? "errorDropdown" : "selectDropdown"}
                    onChange={handleChange}
                    style={{
                        borderColor: touched ? 'red' : '#ccc',

                    }}
                >
                    <option value="" disabled selected>
                        Select a product *
                    </option>

                    {products.map((option) => {
                        return <option key={option} value={option}>{option}</option>
                    })}
                </select>

                <KeyboardArrowDown
                    className='dropdownIcon'
                />
            </div>
            {touched && <p id='error'>Select s product</p>}
        </>

    )
}

export default SelectProduct
